export default "__VITE_ASSET__e12dff70__"